module.exports = __webpack_public_path__ + "img/dhht-3.91f813f7.png";